import React, { useState, useEffect } from "react";
import { SERVER_BASE } from "../config/server";
import apiClient from "../utils/apiClient";
import ReturnAcceptanceTable from "./returnAcceptanceTable";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
const ReturnAcceptance = ({ accessOfDepartments }) => {
  const [returnSlipCode, setReturnSlipCode] = useState("");
  const [returnDetails, setReturnDetails] = useState(null);
  const code = localStorage.getItem('code');
  const email = localStorage.getItem('email');
  const role = localStorage.getItem('role');
  const name = localStorage.getItem('name');
  const badgeId = localStorage.getItem('badgeId');
  const pin = localStorage.getItem('pin');
  const navigate = useNavigate();
  const location = useLocation();
  const type = location?.state?.type;                     // "IR" or "PR"
  const returnSlipCodeState = location?.state?.returnSlipCode;
  const projectRequirementId = location?.state?.projectRequirementId;


  useEffect(() => {
    // 🔹 IR acceptance flow
    if (type === "IR" && returnSlipCodeState) {
      fetchReturnDetails(returnSlipCodeState);
    }
    
    // 🔹 PR acceptance flow
    if (type === "PR" && projectRequirementId) {
      fetchReturnDetailsForRequirement(projectRequirementId);
    }
    setReturnSlipCode(returnSlipCodeState);
  }, [type, returnSlipCodeState, projectRequirementId]);

  const fetchReturnDetails = async (returnSlipCodeState) => {
    if (!returnSlipCodeState) {
      Swal.fire({
        toast: true,
        icon: "warning",
        title: "Please enter a return slip code.",
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }

    try {
      const response = await apiClient.get(`${SERVER_BASE}/getReturnDetails`, {
        params: { returnSlipCode: returnSlipCodeState },
      });
      setReturnDetails(response.data);
    } catch (error) {
      console.error("Error fetching return details:", error);
      alert(error.response?.data?.message || "Failed to fetch return details.");
    }
  };
  // 🔹 Fetch PR return details for acceptance
  const fetchReturnDetailsForRequirement = async (projectRequirementId) => {
    if (!projectRequirementId) {
      Swal.fire({
        toast: true,
        icon: "warning",
        title: "Invalid project requirement.",
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    try {
      const response = await apiClient.get(
        `${SERVER_BASE}/getReturnDetailsForRequirement`,
        { params: { projectRequirementId } }
      );

      setReturnDetails(response.data);

    } catch (error) {
      console.error("Error fetching PR return details:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to fetch return details for requirement",
        position: "top-end",
        toast: true,
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };

  const acceptReturn = async () => {
    if (!returnSlipCode && !projectRequirementId) {
      Swal.fire("Error", "Please fetch the return slip details first.", "error");
      return;
    }

    try {
      // 🔐 Ask for PIN
      Swal.fire({
        title: "Enter your PIN",
        input: "password",
        inputPlaceholder: "Enter your PIN",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonText: "Submit",
        inputValidator: (value) => {
          if (!value) return "Please enter your PIN.";
          if (value !== pin) return "Invalid PIN. Please try again.";
          return null;
        },
      }).then(async (result) => {
        if (!result.isConfirmed) {
          Swal.fire("Cancelled", "Return acceptance was cancelled.", "info");
          return;
        }

        // 🔹 IR FLOW
        if (type === "IR") {
          await apiClient.post(`${SERVER_BASE}/returnAcceptance`, {
            returnSlipCode,
            name,
            badgeId,
          });
        }

        // 🔹 PR FLOW
        if (type === "PR") {
          await apiClient.post(`${SERVER_BASE}/returnAcceptanceForRequirement`, {
            projectRequirementId: projectRequirementId,
            returnSlipCode,
            name,
            badgeId,
          });
        }

        Swal.fire("Success", "Return accepted successfully!", "success");
        setReturnSlipCode("");
        setReturnDetails(null);
        navigate(-1);
      });

    } catch (error) {
      console.error("Error accepting return:", error);
      Swal.fire("Error", error.response?.data?.message || "Failed to accept return", "error");
    }
  };



  return (
    <div className="formcontainer mt-5">
      <h3>Return Acceptance</h3>

      {returnDetails && (
        <div>
          <p>
            <strong>Receiving Department:</strong>{" "}
            {returnDetails.receivingDepartment}
          </p>
          <p>
            <strong>Issuer Department:</strong>{" "}
            {returnDetails.issuerDepartment}
          </p>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row fw-bold mb-2">
                    <div className="col-md-4">Item</div>
                    <div className="col-md-1">Issued</div>
                    <div className="col-md-2">Returnable</div>
                    <div className="col-md-1">Returned</div>
                    <div className="col-md-1">UOM</div>
                    <div className="col-md-3">Remarks</div>
                  </div>
                  {returnDetails.inventory.map((item, index) => (
                    <div
                      className="row mb-2 align-items-center"
                      key={index}
                    >
                      <div className="col-md-4">
                        <input
                          type="text"
                          className="form-control"
                          value={item.itemName}
                          readOnly
                        />
                      </div>
                      <div className="col-md-1">
                        <input
                          type="number"
                          className="form-control"
                          value={item.issuedQuantity}
                          readOnly
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          type="text"
                          className="form-control"
                          value={item.returnable}
                          readOnly
                        />
                      </div>
                      <div className="col-md-1">
                        <input
                          type="number"
                          className="form-control"
                          value={item.returnedQuantity}
                          readOnly
                        />
                      </div>
                      <div className="col-md-1">
                        <input
                          type="text"
                          className="form-control"
                          value={item.uom}
                          readOnly
                        />
                      </div>.
                      <div className="col-md-2">
                        <input
                          type="text"
                          className="form-control"
                          value={item.remarks}
                          readOnly
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <button className="btn btn-success mt-3" onClick={acceptReturn}>
            Accept Return
          </button>
        </div>
      )}
    </div>
  );
};

export default ReturnAcceptance;
